export const removeSplashPage = (): void => {
  // Animate and remove the splash page
  setTimeout(() => document.getElementById('preloading')?.classList.add('preloaderFadeOut'));
  setTimeout(() => document.getElementById('preloading')?.remove(), 200);
};
